/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const variables = `
AccX 
AccY 
AccZ 
BinFstep
BinNum
fftX
fftY
fftZ
AdvertenciaWord1
AdvertenciaWord2
AdvertenciaWord3
AdvertenciaWord4
Alm_H_CorrenteMedia
Alm_H_DriverTorque
Alm_H_PotenciaAtivaMedia
Alm_H_PotenciaHidricaDisponivel
Alm_H_Rotacao
Alm_H_TamperaturaEstatorFaseR
Alm_H_TamperaturaEstatorFaseS
Alm_H_TamperaturaEstatorFaseT
Alm_H_TemperaturaAxial
Alm_H_TemperaturaRadial
Alm_H_Vibracao3oEixo
Alm_H_VibracaoAxial
Alm_H_VibracaoRadial
Alm_L_DPS
Alm_L_DisjValBypass
Alm_L_DisjValEntrada
Alm_L_DisjValPrincipal
Alm_L_DriverFalha
Alm_L_DriverOffLine
Alm_L_Emergencia
Alm_L_MgeOfflineData1
Alm_L_MgeOfflineData2
Alm_L_Nivel1
Alm_L_Nivel2
Alm_L_Vazao
Alr1 
Alr2 
Batt
Blk_Aguardando120sParaLiberarPartida
Blk_FaltaEnergiaPotencialHidraulica
BloqueioWord1
BloqueioWord2
BloqueioWord3
BloqueioWord4
CMDWord1
CMDWord2
CMDWord3
CMDWord4
CMD_Abre_Vrp
CMD_BuscaPotMax
CMD_Ctrl_Potencia
CMD_Ctrl_Press
CMD_Ctrl_Vaz
CMD_Desliga
CMD_Fecha_Vrp
CMD_Liga
CMD_ModoAutomatico
CMD_ModoManual
CMD_Rearme
CMD_Reset_Horimetro
Comunicacao
Contador
CorrenteDeNeutro
CorrenteDriver
CorrenteMedia
CorrenteR
CorrenteS
CorrenteSaidaDrive
CorrenteT
Demanda
DemandaAtiva
DemandaAtivaReversa
DemandaCalculada
DemandaCapacitiva
DemandaCapacitivaReversa
DemandaIndutiva
DemandaIndutivaReversa
DriverCodigoAlarme
DriverCodigoFalha
DriverCodigoStatus
DriverControlWord
DriverStatusWord
EnergiaAcumulada
EnergiaAtiva
ActE
EnergiaAtivaDiretaDriver
EnergiaAtivaReversa
EnergiaAtivaReversaDriver
EnergiaAtivaTotalDriver
EnergiaCap
EnergiaCapacitivaReversa
EnergiaConsumidaTotal
EnergiaIndutiva
EnergiaIndutivaReversa
ErroAtivo
FatorPotenciaMedio
FatorPotenciaR
FatorPotenciaS
FatorPotenciaT
FeedbackAtuador
FeedbackVa
FeedbackVb
FeedbackVe
FeedbackVp
FPR 
FPS 
FPT 
FP
Freq
Frequencia
HabAdvertenciaWord1
HabAdvertenciaWord2
HabAdvertenciaWord3
HabAdvertenciaWord4
HabAlarmeWord1
HabAlarmeWord2
HabAlarmeWord3
HabAlarmeWord4
HabBloqueioWord1
HabBloqueioWord2
HabBloqueioWord3
HabBloqueioWord4
HabTripWord1
HabTripWord2
HabTripWord3
HabTripWord4
Hab_Alm_BotaoEmergencia
Hab_Alm_CorrenteGeradorAlta
Hab_Alm_DPS
Hab_Alm_DisjValBypass
Hab_Alm_DisjValEntrada
Hab_Alm_DisjValPrincipal
Hab_Alm_DriverEmFalha
Hab_Alm_DriverOffLine
Hab_Alm_DriverTorqueAlta
Hab_Alm_MGE_OffLine_Leitura1
Hab_Alm_MGE_OffLine_Leitura2
Hab_Alm_NivelAgua1Baixo
Hab_Alm_NivelAgua2Baixo
Hab_Alm_PotenciaGeradorAlta
Hab_Alm_RotacaoGeradorAlta
Hab_Alm_TempAxialAlta
Hab_Alm_TempEstatorRAlta
Hab_Alm_TempEstatorSAlta
Hab_Alm_TempEstatorTAlta
Hab_Alm_TempRadialAlta
Hab_Alm_UCHAPotencialHidraulicoAlto
Hab_Alm_UCHAVazaoBaixa
Hab_Alm_VibAxialAlta
Hab_Alm_VibEixoZ
Hab_Alm_VibRadialAlta
Hab_Blk_Aguardando120sParaLiberarPartida
Hab_Blk_FaltaEnergiaPotencialHidraulica
Hab_Trip_F27
Hab_Trip_F47
Hab_Trip_F59
Hab_Trip_F67
Hab_Trip_F67N
Hab_Trip_F81O
Hab_Trip_F81U
Hor
HorimetroParcial
HorimetroParcialMinutos
HorimetroParcialSegundos
HorimetroTotalizador
HorimetroTotalizadorMinutos
HorimetroTotalizadorSegundos
Iavg 
IR 
IS 
IT 
Lat
Lon 
Lvl1 
Lvl2  
Nivel1
Nivel1Gerador
Nivel2
Nivel1Bomba
Nivel2Bomba
Nivel2Gerador
NivelHorizontal
NivelVertical
NivelJusante
NivelJusanteGradeamento
NivelMontante
NivelDoReservatorio
PosicaoDaComporta
Par_AmplitudeMax
Par_DriverRotacaoMax
Par_FreqMaxF81O
Par_FreqMinF81U
Par_GanhoIntegral
Par_GanhoProporcional
Par_Ki_Bypass
Par_Ki_Gerador
Par_Kp_Bypass
Par_Kp_Gerador
Par_NoDePassos
Par_TempoEntrePassos
Par_TempoIntregracao
Par_TensaoDaRedeEletrica
Par_TensaoMaxF59
Par_TensaoNimF27
Par_Ti_Bypass
Par_Ti_Gerador
Par_pt_desbtensao_tempo
Par_pt_desbtensao
Par_pt_desbcorrente_tempo
Par_pt_desbcorrente
Par_pt_rotacao_tempo
Par_pt_rotacao_comporta
Par_pt_rotacao
Par_pt_potreversa_tempo
Par_pt_potreversa
Par_pt_subtensao_tempo
Par_pt_fp_tempo
Par_pt_fp_tempo_partida
Par_pt_fp_tol_fim
Par_pt_fp_tol_ini
Par_bs_rel_tp_sec
Par_bs_rel_tp_pri
Par_bs_rel_tc_sec
Par_bs_rel_tc_pri
Par_bs_velocidade
Par_bs_potencia
Par_fp_max
Par_fp_min
Par_pulsos_encoder
Par_veloc_sincronismo
PotenciaAparenteFaseR
PotenciaAparenteFaseS
PotenciaAparenteFaseT
PotenciaAparenteMedia
PotenciaAtivaDriver
PotenciaAtivaFaseR
PotenciaAtivaFaseS
PotenciaAtivaFaseT
PotenciaAtivaMedia
PotenciaHidricaDisponivel
PotenciaReativaFaseR
PotenciaReativaFaseS
PotenciaReativaFaseT
PotenciaReativaMedia
PotenciaSaidaDrive
Press
PressaoAlimentacao
PressaoDescarga
PressaoDiferencial
PressaoRecalque
RefCtrlVa
RefCtrlVb
RefCtrlVe
RefCtrlVp
Rendimento
RendimentoBomba
RendimentoTurbina
Rotacao
RotacaoHSC
Rev
RevE
SnrSup 
SnrGat 
SPAlmAltoTamperaturaEstatorFaseR
SPAlmAltoTamperaturaEstatorFaseS
SPAlmAltoTamperaturaEstatorFaseT
SPAlmAltoTemperaturaAxial
SPAlmAltoTemperaturaRadial
SPAlmAltoVibracao3oEixo
SPAlmAltoVibracaoAxial
SPAlmAltoVibracaoRadial
SPAlmCorrenteGeradorAlta
SPAlmPotenciaGeradorAlta
SPAlmPotencialHidraulicoAltoUCHA
SPAlmRotacaoGeradorAlta
SPAlmTorqueDriverAlta
SPAlmVazaoBaixoUCHA
SPAmplitudeMax
SPByPass
SPFeedbackVb
SPFeedbackVe
SPFeedbackVp
SPGanhoIntegral
SPGanhoProporcional
SPNoDePassos
SPPressaoDescarga
SPPressaoDifParada
SPPressaoDifPartida
SPReferenciaGerador
SPReferenciaPartida
SPRotacaoGeradorMax
SPRotacaoGeradorMin
SPTarifa
SPTempoEntrePassos
SPTempoIntregracao
SPVazao
SP_Alm_H_CorrenteMedia
SP_Alm_H_PotenciaAtivaMedia
SP_Alm_H_PotenciaHidricaDisponivel
SP_Alm_H_Rotacao
SP_Alm_H_TamperaturaEstatorFaseR
SP_Alm_H_TamperaturaEstatorFaseS
SP_Alm_H_TamperaturaEstatorFaseT
SP_Alm_H_TemperaturaAxial
SP_Alm_H_TemperaturaEstatorFaseR
SP_Alm_H_TemperaturaEstatorFaseS
SP_Alm_H_TemperaturaEstatorFaseT
SP_Alm_H_TemperaturaRadial
SP_Alm_H_Torque
SP_Alm_H_Vibracao3oEixo
SP_Alm_H_VibracaoAxial
SP_Alm_H_VibracaoRadial
SP_Alm_L_TensaoDC
SP_Alm_L_Vazao
SP_Oper_Controle
SP_Oper_FeedbackVb
SP_Oper_FeedbackVe
SP_Oper_FeedbackVp
SP_Oper_Limite
SP_Oper_Ngem
SP_Oper_Ni
SP_Oper_Nmec
SP_Oper_Parada
SP_Oper_Partida
SP_Oper_PressaoDescarga
SP_Oper_PressaoDifParada
SP_Oper_PressaoDifPartida
SP_Oper_Ref_Gerador
SP_Oper_Ref_Va
SP_Oper_Ref_Vb
SP_Oper_Ref_Ve
SP_Oper_Ref_Vp
SP_Oper_ReferenciaGerador
SP_Oper_ReferenciaPartida
SP_Oper_RotacaoGeradorMax
SP_Oper_RotacaoGeradorMin
SP_Oper_Tarifa
SP_Oper_Vazao
Sta_Bloqueado
Sta_ConsumindoEnergia
Sta_ControlePotenciaAtivo
Sta_ControlePressaoAtivo
Sta_ControleVazaoAtivo
Sta_Desconectado
Sta_EmAlarme
Sta_EmAutomatico
Sta_EmManual
Sta_Parado
Sta_PartidaLiberada
Sta_Partindo
Sta_Partiu
Sta_PresDiferencialMinParada
Sta_PresDiferencialMinPartida
Sta_Rodando
Sta_Scanning
Sta_SemAlarme
Sta_VPR_Aberta
TamperaturaEstatorFaseR
TamperaturaEstatorFaseS
TamperaturaEstatorFaseT
TemperaturaAxial
TempAx
TmpAx
TempRad
TmpRa 
TempR
TmpR 
TempS
TmpS 
TempT
TmpT 
TmpCPU
TemperaturaEstatorFaseR
TemperaturaEstatorFaseS
TemperaturaEstatorFaseT
TemperaturaPainel
TemperaturaDoPainel
TemperaturaRadial
TemperaturaTrafo
TensaoBarramentoDC
TensaoDaRedeEletrica
TensaoLinkCCDrive
TensaoMedia
TensaoSaidaDrive
TensaoR
TensaoS
TensaoT
THDVR 
THDVRS 
THDVST 
THDVTR 
THDIR 
THDIS 
THDIT 
THDVS
THDVT
SpvOk
MgeOk
Tilt 
Torque
TotalizadorVazaoAnual
TotalizadorVazaoDiario
TotalizadorVazaoMensal
Trip_Funcao_27
Trip_Funcao_47
Trip_Funcao_59
Trip_Funcao_67
Trip_Funcao_67N
Trip_Funcao_81O
Trip_Funcao_81U
UltimoErro
VAR 
VA 
ValorEconomizado
Vazao
VazaoAdutora
VazaoGlobal
VazaoSABESP
VazaoToraqua
VelX 
VelY 
VelZ 
Vibracao3oEixo
VibracaoAxial
VibracaoRadial
VolumeTotal
Vcpu 
VFavg 
VFR 
VFS 
VFT 
VLavg 
VLRS 
VLST 
VLTR 
Vsns 
Vsup 
W 
WR 
WS 
WT 
dataUpdate
thingName
timestampUpdate
Trp1 
Trp2 
ts
SP_Oper_Nmot
SP_Oper_RotacaoBombaMax
SP_Oper_RotacaoBombaMin
SP_Oper_Ref_Bomba
Par_Ti_Bomba
Par_Ki_Bomba
Par_Kp_Bomba
DriverCodigoControle
DriverCodigoStatus
Sta_ValDescargaFechadaEmAutomatico
Sta_ValDescargaAbertaEmAutomatico
Sta_PidBombaDireto
Sta_PidBombaReverso
Sta_PidByPassDireto
Sta_PidByPassReverso
Sta_PidValDescargaDireto
Sta_Nivel1Ok
Sta_Nivel2Ok
Sta_PidValDescargaReverso
Sta_Vb_Fechada
Sta_BombaOperandoNaRotacaoMin
Sta_BombaOperandoNaRotacaoMax
Sta_ByPassFechadoEmAutomatico
Sta_ByPassAbertoEmAutomatico
`;

export const onDeleteIOT = /* GraphQL */ `
  subscription OnDeleteIOT($thingName: String!) {
    onDeleteIOT(thingName: $thingName) {
      ${variables}
    }
  }
`;

export const onUpdateIOT = /* GraphQL */ `
  subscription OnUpdateIOT($thingName: String!) {
    onUpdateIOT(thingName: $thingName) {
      ${variables}
    }
  }
`;
